export function lenisScroll() {
    if (!window.lenis && typeof Lenis !== 'undefined') {
        window.lenis = new Lenis({
            smooth: true,
            lerp: 0.2, 
            duration: 0.5, 
            smoothTouch: true,
        });

        function raf(time) {
            window.lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);

        if (window.ScrollTrigger) {
            window.lenis.on('scroll', ScrollTrigger.update);
        }
    }
}
